import { AlertTriangle } from 'lucide-react';

export function Section5PrereqNotice({ title, description }: { title: string; description: string }) {
  return (
    <div className="rounded-card border border-outline bg-warning/10 p-4 text-on-surface">
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-warning" />
        <div>
          <p className="text-data-md font-semibold text-on-surface">{title}</p>
          <p className="mt-1 text-body-sm text-on-surface-variant">{description}</p>
        </div>
      </div>
    </div>
  );
}
